export default {
  warehouse: []
};
